export default {
  warehouse: []
};
